const INCDATARESPONSE = () =>localStorage.getItem('solutionsAnalysisResponse');

export default INCDATARESPONSE;